














































import { Component, Vue } from 'vue-property-decorator';
import TokenisedPhrase, { ManualRecognitionResult } from '../components/TokenisedPhrase.vue';
import ChatBalloon from '@/components/ChatBalloon.vue';
import VoiceInput from '@/components/VoiceInput.vue';
import { resolveIntent } from 'js-nlp';
import {BotData, ResponseMessages, ResponseToUser} from '@/store-types';
import { OpenConversation, RequestFromUser } from '../store-types';
import ContextChip from '../components/ContextChip.vue';
import {IntentResult} from 'js-nlp/lib/intent';

@Component<Chat>({
  components: {
    ContextChip,
    TokenisedPhrase,
    ChatBalloon,
    VoiceInput
  },
  created() {
    (this as any).unsubscribe = this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        // case 'message_added':
        //   if ((mutation.payload as RequestFromUser).conversationId === this.conversationId) {
        //     this.addMessage(mutation.payload);
        //   }
        //   break;
        case 'messages_loaded':
          this.onMessagesLoaded();

          // .getElementById('voiceInput')
          // this.request = mutation.payload.messages.pop();
          break;
      }
    });
  },
  beforeDestroy() {
    (this as any).unsubscribe();
  },
  watch: {
    request(newRequest: RequestFromUser) {
      console.info('newRequest:', newRequest);
      if (newRequest) {
          this.response = (newRequest as any).response;
      }
    },
    $route: 'onRoute'
  }
})
export default class Chat extends Vue {
    private loading = true;
    private phraseFocused = false;
    private intent = null;
    // private conversation: OpenConversation = null as any;
    // private request: RequestFromUser = null as any;
    private response: ResponseMessages | null = null;

    get bot(): BotData {
        return this.$store.state.bots[this.$route.params.botId];
    }

    get conversationId() {
        return this.$route.params.conversationId;
    }

    get intents(): string[] | undefined {
        console.info('caching intents:', this.bot && this.bot.intents); // , this.request);
        return this.bot && this.bot.intents && Object.keys(this.bot.intents);
    }

    get request() {
        console.info('caching request', this.$store.state.request);
        console.info('  loading:', this.loading, this.$store.state.openConversations[this.conversationId]);
        // return this.$store.state.request;
        // if (this.loading) {
        //   return null;
        // }

        const conv = this.$store.state.openConversations[this.conversationId] as OpenConversation;
        if (conv && conv.messages) {
            const request = conv.messages[conv.messages.length - 1];
            if (request) {
                delete (request.contexts as any).wait_for_response;
            }
            return request;
        }
        return null;
    }

    private onRoute() {
        console.info('onRoute:', this.$route.params);
        if (this.conversationId) {
            // console.info('fetching data for conversation', this.$route.params.conversationId);
            // const conv = this.$store.state.conversations[this.conversationId] as Conversation;
            // this.request = null;
            // this.conversation = this.$store.state.openConversations[this.conversationId] as OpenConversation;
            const conv = this.$store.state.openConversations[this.conversationId] as OpenConversation;
            if (!conv.messages.length) {
                this.loading = true;
            } else {
                this.onMessagesLoaded();
            }
        }
    }

    private onMessagesLoaded() {
        // if (!this.conversation) {
        //     this.conversation = this.$store.state.openConversations[this.conversationId] as OpenConversation;
        // }

        // console.info('messages loaded for conv:', this.conversation);
        this.loading = false;
        // if (this.conversation) {
        //     this.request = this.conversation.messages[this.conversation.messages.length - 1] as RequestFromUser;
        //     if (this.request) {
        //         this.response = (this.request as any).response;
        //         delete (this.request.contexts as any).wait_for_response;
        //     }
        // }

        // console.info('need to focus:', this.$el);
        // setTimeout(() => {
        //     // debugger;https://www.facebook.com/messages/t/701653824
        //     // this.$el.getElementsByClassName('utterance')[0].focus();
        // }, 10);
    }

    private onRecognition(rec: ManualRecognitionResult) {
        const intents = (this.bot as BotData).intents;
        const entities = (this.bot as BotData).entities;
        const request = this.request as RequestFromUser;
        function getContext(intentName: string): {[name: string]: string} | undefined {
            for (const ctx of request.contexts!) {
                if (ctx.name === intentName) {
                    return ctx.parameters;
                }
            }
        }
        console.info('recognition:', rec);
        this.$data.recognisedText = rec.utterance;
        resolveIntent(rec.utterance,
                      intents!,
                      entities!,
                      rec.parameters,
                      getContext as any,
                      (err: Error, result: IntentResult[]) => {
                          if (result) {
                              this.$data.intent = result[0].intent;
                          }
                      });
    }

    private onIntent(intent: string) {
        console.info('intent:', intent);
    }

    private onResponse(response: {value: string; inputType: 'keyboard' | 'voice'}) {
        // console.info('onResponse:', response);
        // console.info('Chat.this:', this);
        // debugger;
        const resp: ResponseToUser = {
            conversationId: this.$route.params.conversationId,
            requestId: this.request!.requestId,
            agentId: this.$store.state.user.id,
            /*contexts: Array<{
              name: string;
              lifespan?: number;
              parameters: { [name: string]: string };
            }>;*/
            response: {
                // intent: this.intent // || 'Default Fallback Intent',
                messages: [response]
                // speech?: string;
            },
            nlpResult: {
                text: this.$data.recognisedText || (this.request as RequestFromUser).query
            }
        };
        if (this.intent) {
            resp.nlpResult.intent = this.intent!;
        }
        this.response = resp.response;
        // this.$store.commit('message_modified', this.request);
        this.$store.dispatch('sendResponse', resp);
    }
}
